export default __webpack_public_path__ + "static/media/P20-sm-open.0dca2069.svg";